import * as React from "react"
import { Form } from "informed"
import debounce from "lodash.debounce"
import DateRadio from "./DateRadio"
import PeriodRadio from "./PeriodRadio"
import SelectDropdown from "./SelectDropdown"
import { defineMessages, IntlShape } from "react-intl"
import { breakpoints } from "../../modules/screen"
import { IWhere2goState } from "../../redux/actions/where2go"
import * as s from "./style.scss"

interface IProps {
    formatMessage
    initialValues: IWhere2goState
    onChange: (values: object) => void
}

const messages = defineMessages({
    radiusLabel: {
        defaultMessage: "Radius",
        id: "label_radius",
    },
    afternoon: {
        defaultMessage: "Afternoon",
        id: "period_afternoon",
    },
    morning: {
        defaultMessage: "Morning",
        id: "period_morning",
    },
    wholeDay: {
        defaultMessage: "Whole day",
        id: "period_wholeDay",
    },
    today: {
        defaultMessage: "Today",
        id: "day_today",
    },
    tomorrow: {
        defaultMessage: "Tomorrow",
        id: "day_tomorrow",
    },
    monday: {
        defaultMessage: "Monday",
        id: "day_monday",
    },
    tuesday: {
        defaultMessage: "Tuesday",
        id: "day_tuesday",
    },
    wednesday: {
        defaultMessage: "Wednesday",
        id: "day_wednesday",
    },
    thursday: {
        defaultMessage: "Thursday",
        id: "day_thursday",
    },
    friday: {
        defaultMessage: "Friday",
        id: "day_friday",
    },
    saturday: {
        defaultMessage: "Saturday",
        id: "day_saturday",
    },
    sunday: {
        defaultMessage: "Sunday",
        id: "day_sunday",
    },
})


const getFiveDays = (formatMessage, isMobile: boolean): { value: number, description: string }[] => {
    const names = [
        formatMessage(messages.sunday),
        formatMessage(messages.monday),
        formatMessage(messages.tuesday),
        formatMessage(messages.wednesday),
        formatMessage(messages.thursday),
        formatMessage(messages.friday),
        formatMessage(messages.saturday),
    ]
    const today = new Date()

    const fiveDay: { value: number, description: string }[] = []
    const nextDay = new Date()

    for (let i = 0; i <= 4; i++) {
        if (i === 0) {
            nextDay.setDate(nextDay.getDate())
        } else {
            nextDay.setDate(nextDay.getDate() + 1)
        }

        if (!isMobile && nextDay.getDay() === today.getDay()) {
            fiveDay.push({ value: i, description: formatMessage(messages.today) })
        } else if (!isMobile && nextDay.getDay() === today.getDay() + 1) {
            fiveDay.push({ value: i, description: formatMessage(messages.tomorrow) })
        } else {
            if (isMobile) {
                fiveDay.push({ value: i, description: names[nextDay.getDay()].substring(0, 3) })
            } else {
                fiveDay.push({ value: i, description: names[nextDay.getDay()] })
            }
        }
    }

    return fiveDay
}


export default ({ formatMessage, initialValues, onChange }: IProps) => {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < breakpoints.TABLET)

    const periodItems = [
        { value: 0, description: formatMessage(messages.morning) },
        { value: 1, description: formatMessage(messages.afternoon) },
        { value: 2, description: formatMessage(messages.wholeDay) },
    ]

    const radiusSelectItems = [
        { value: 30, description: "30 km" },
        { value: 60, description: "60 km" },
        { value: 100, description: "100 km" },
        { value: 150, description: "150 km" },
        { value: 200, description: "200 km" },
        { value: 300, description: "300 km" },
        { value: 400, description: "400 km" },
        { value: 500, description: "500 km" },
    ]

    const fiveDay = getFiveDays(formatMessage, isMobile)

    const onResize = debounce(() => {
        if ((window.innerWidth > breakpoints.TABLET) === isMobile) {
            setIsMobile(!isMobile)
        }
    }, 200)

    React.useEffect(() => {
        window.addEventListener("resize", onResize)

        return () => {
            window.removeEventListener("resize", onResize)
        }
    }, [isMobile])

    return (
        <Form onChange={onChange}>
            <div className={s.formGroup}>
                <DateRadio
                    days={fiveDay}
                    initialDate={initialValues.date}
                />
                <PeriodRadio
                    periodItems={periodItems}
                    initialPeriod={initialValues.period}
                />
                <SelectDropdown
                    radiusItems={radiusSelectItems}
                    initialRadius={initialValues.radius}
                    label={formatMessage(messages.radiusLabel)}
                />
            </div>
        </Form>
    )
}